(function ($, Cobalt, undefined) {
    Cobalt.Billing = {
        initialize: function () {
            this.bindSameAddressCheckbox();

            function showStateForNonUS(countrySelector, stateSelector) {
                $(countrySelector).change(function () {
                    if ($(this).val() != "US") {
                        $(stateSelector).val("");
                        $(stateSelector).parent().hide();
                    } else {
                        $(stateSelector).parent().show();
                    }
                }).change();
            }
            showStateForNonUS("#field-billing-country", "#field-billing-state");
            showStateForNonUS("#field-shipping-country", "#field-shipping-state");
           
        },
        bindSameAddressCheckbox: function() {
            $("#field-same-address").click(function () {
                var $this = $(this);
                var $billingForm = $("#billing-address");

                if ($this.attr('checked')) {
                    $billingForm.hide();
                } else {
                    $billingForm.show();
                }
            });

            $("#checkout").submit(function () {
                syncAddressesIfNecessary();
            });

            function syncAddressesIfNecessary() {
                var field = $("#field-same-address")[0];
                if (!field) { return; }
                var sameAddress = field.checked;
                if (sameAddress) {
                    $("#field-billing-first-name").val($("#field-shipping-first-name").val());
                    $("#field-billing-last-name").val($("#field-shipping-last-name").val());
                    $("#field-billing-street-address-1").val($("#field-shipping-street-address-1").val());
                    $("#field-billing-street-address-2").val($("#field-shipping-street-address-2").val());
                    $("#field-billing-locality").val($("#field-shipping-locality").val());
                    $("#field-billing-state").val($("#field-shipping-state").val());
                    $("#field-billing-postal-code").val($("#field-shipping-postal-code").val());
                    $("#field-billing-country").val($("#field-shipping-country").val());
                }
            }
        }
    }
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Billing.js